/**
 * Live Transcription Atoms
 *
 * Atoms for managing Web Speech API live transcription preview.
 */
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

// ============================================================================
// Base Atoms
// ============================================================================

/** Array of finalized transcript segments */
export const liveTranscriptAtom = atom<string[]>([]);

/** Current interim (not yet finalized) transcript text */
export const liveInterimTranscriptAtom = atom<string>('');

/** User preference for live transcription (persisted) */
export const isLiveTranscriptionEnabledAtom = atomWithStorage<boolean>(
  'videa-notes-live-transcription',
  true,
);
